<template>
  <div class="man-hour">
    <CustomTitle title="部门未完成工时统计" />
    <div class="chart">
      <Echart id="manHour" :options="option" height="100%" width="100%" />
    </div>
  </div>
</template>

<script>
import Echart from '@/common/echart'
import CustomTitle from '@/components/CustomTitle'
import config from '@/js/config'

export default {
  name: 'ManHour',
  data () {
    return {
      option: {
        series: [
          {
            type: 'pie',
            data: [
              // { name: '收费系统', value: 93 },
              // { name: '通信系统', value: 66 },
              // { name: '监控系统', value: 52 },
              // { name: '供配电系统', value: 34 },
              // { name: '其他', value: 22 }
            ],
            radius: ['45%', '60%'],
            insideLabel: {
              show: false
            },
            outsideLabel: {
              labelLineEndLength: 10,
              formatter: '{name}:{percent}%={value}h',
              style: {
                fontSize: 14,
                fill: '#fff'
              }
            }
          }
        ],
        color: ['#00baff', '#3de7c9', '#fff', '#ffc530', '#469f4b']
      },
      requestTimer: null,
      retryTimer: null,// 重试延时器
      requestUrl: '',
      compid:0,
    }
  },
  components: {
    CustomTitle,
    Echart
  },
  watch: {},
  methods: {
    getdepwkhours () {
      clearTimeout(this.retryTimer)
      this.compid = window.localStorage.getItem('bsmcompid')
      this.dept = window.localStorage.getItem('bsmdept')
      var dat={ compid: this.compid }
      // alert ("this.compid"+this.compid);
      this.axios({
        method: 'post',
        //params: JSON.stringify(dat),
        //url: 'http://47.107.138.238/bsmtp/public/admin.php/Bigsreen/prowhsumfun',
        url:this.requestUrl+ '/admin.php/Bigsreen/prowhsumfun?compid='+ this.compid,

      })
        .then(Response => {
          var wkhs = JSON.parse(Response.data)
          // alert (Response.data);
          var noprowk = wkhs[3]
          let wkconf = {
            color: [
              '#9AFF9A',
              '#326092',
              '#6666cc',
              '#99ff66',
              '#BC8F8F',
              '#2c7eeb',
              '#2ffff4',
              '#3dc6c8',
              '#4d8fc6',
              '#00baff',
              '#3de7c9',
              '#33cc33',
              '#fff',
              '#ffc530',
              '#469f4b'
            ],
            title: {
              text: '0',
              subtext: '总计工时',
              x: '24%',
              y: '35%',
              textAlign: 'center',
              textStyle: {
                fontSize: 24,
                color: '#FFFFFF',
                // lineHeight: '26px',
                fontFamily: 'Bebas'
              },
              subtextStyle: {
                color: '#FFFFFF',
                fontSize: 12,
                fontFamily: 'PingFang SC'
              }
            },
            legend: {
              itemHeight: 8, // 图例icon高度
              itemWidth: 8, // 图例icon宽度
              orient: 'vertical',
              show: true,
              itemGap: 4,
              right: '10%',
              top: 'middle',
              type: 'scroll', // 可滚动翻页的图例
              pageIconSize: 8, // 翻页按钮大小
              pageIconColor: '#2C86FF', // 翻页箭头颜色
              pageIconInactiveColor: 'rgba(44,132,251,0.40)', // 翻页（即翻页到头时箭头的颜色
              pageTextStyle: {
                color: '#999' // 翻页数字颜色
              },
              textStyle: {
                rich: {
                  title: {
                    fontSize: 12,
                    color: '#fff'
                  },
                  valueColor: {
                    fontSize: 12,
                    color: '#48E5E5'
                  }
                }
              },
              formatter: function (p) {
                const total = wkhs[3].reduce((pre, cur) => {
                  return pre + cur.value
                }, 0)
                const currentItem = wkhs[3].find(item => item.name === p)
                return `{title|${p}：${(
                  (currentItem.value / total) *
              100
                ).toFixed(0)}%} {valueColor|${currentItem.value.toFixed(0)}h} `
              }
            },
            series: [
              {
                type: 'pie',
                data: noprowk,
                radius: ['55%', '75%'],
                center: ['25%', '40%'],
                label: {
                  show: false
                }

              }
            ]
          }
          let aa = noprowk.reduce((total, obj) => {
            return obj.value + total
          }, 0)
          wkconf.title.text = aa.toFixed(1)
          this.option = wkconf
          this.sumwks = aa.toFixed(1)
          var ss = [{ newwks: wkhs[0]['sum'], okwks: wkhs[1]['sum'] }]
          this.$eventBus.$emit('Salesumwokhours', ss)
        })
        .catch((error) => {
          console.log(error)
          alert ("error"+error);
          this.retryTimer = setTimeout(() => {
            this.getdepwkhours()
          }, config.retryTime)
        })
    }
  },
  created () {
    this.requestUrl=window.localStorage.getItem('requestUrl')
    this.getdepwkhours()
  },
  mounted () {
    this.requestTimer = setInterval(() => {
      this.getdepwkhours()
    }, config.refreshTime.manHour)
  },
  beforeDestroy () {
    clearInterval(this.requestTimer)
    clearTimeout(this.retryTimer)
  }
}
</script>

<style scoped lang="less">
// .man-hour {
//   display: flex;
//   flex-direction: column;
//   width: 100%;
//   height: 100%;
//   overflow: hidden; // 防止内容溢出
  
//   .chart {
//     flex: 1;
//     position: relative;
//     width: 100%;
//     min-width: 300px; // 设置最小宽度防止过小
    
//     // 针对小屏幕的调整
//     @media (max-width: 768px) {     
//       .echarts {
//         // 调整图例位置
//         .echarts-legend {
//           right: 5% !important;
//           left: auto !important;
//         }
        
//         // 调整饼图中心位置
//         .echarts-series {
//           transform: scale(0.9);
//           transform-origin: center;
//         }
//       }
//     }
//   }
// }

.man-hour {
  display: flex;
  flex-direction: column;
  .chart {
    flex: 1;
  }
  .statistic {
    padding: 0px 50px;
    height: 42px;
    background-image: url("~@/assets/images/bigscreenSales/title.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    display: flex;
    align-items: center;
    justify-content: center;
    &-con {
      width: 100%;
      display: flex;
      justify-content: space-between;
      .statistic-item {
        font-family: "D-DIN";
        font-weight: 400;
        font-size: 12px;
        color: #c6d1db;
        .num {
          height: 30px;
          font-weight: 700;
          font-size: 24px;
          line-height: 30px;
          color: #f3f6fa;
          margin-right: 4px;
        }
      }
    }
  }
}



</style>



// WEBPACK FOOTER //
// src/views/bigscreenSales/components/ManHour.vue